/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Credit_Exhaustion_Cover_LettersInputs */

const en_credit_exhaustion_cover_letters = /** @type {(inputs: Credit_Exhaustion_Cover_LettersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Generated ${i?.count} cover letters`)
};

const de_credit_exhaustion_cover_letters = /** @type {(inputs: Credit_Exhaustion_Cover_LettersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Anschreiben erstellt`)
};

const fr_credit_exhaustion_cover_letters = /** @type {(inputs: Credit_Exhaustion_Cover_LettersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} lettres de motivation générées`)
};

const es_credit_exhaustion_cover_letters = /** @type {(inputs: Credit_Exhaustion_Cover_LettersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} cartas de presentación generadas`)
};

const it_credit_exhaustion_cover_letters = /** @type {(inputs: Credit_Exhaustion_Cover_LettersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} lettere di presentazione generate`)
};

const nl_credit_exhaustion_cover_letters = /** @type {(inputs: Credit_Exhaustion_Cover_LettersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} motivatiebrieven gegenereerd`)
};

const pl_credit_exhaustion_cover_letters = /** @type {(inputs: Credit_Exhaustion_Cover_LettersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wygenerowano ${i?.count} listów motywacyjnych`)
};

const fi_credit_exhaustion_cover_letters = /** @type {(inputs: Credit_Exhaustion_Cover_LettersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Luotu ${i?.count} saatekirjettä`)
};

const da_credit_exhaustion_cover_letters = /** @type {(inputs: Credit_Exhaustion_Cover_LettersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Genereret ${i?.count} ansøgningsbreve`)
};

const sv_credit_exhaustion_cover_letters = /** @type {(inputs: Credit_Exhaustion_Cover_LettersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Genererat ${i?.count} personliga brev`)
};

/**
* | output |
* | --- |
* | "Generated {count} cover letters" |
*
* @param {Credit_Exhaustion_Cover_LettersInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const credit_exhaustion_cover_letters = /** @type {((inputs: Credit_Exhaustion_Cover_LettersInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Credit_Exhaustion_Cover_LettersInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_credit_exhaustion_cover_letters(inputs)
	if (locale === "fr") return fr_credit_exhaustion_cover_letters(inputs)
	if (locale === "es") return es_credit_exhaustion_cover_letters(inputs)
	if (locale === "it") return it_credit_exhaustion_cover_letters(inputs)
	if (locale === "nl") return nl_credit_exhaustion_cover_letters(inputs)
	if (locale === "pl") return pl_credit_exhaustion_cover_letters(inputs)
	if (locale === "fi") return fi_credit_exhaustion_cover_letters(inputs)
	if (locale === "da") return da_credit_exhaustion_cover_letters(inputs)
	if (locale === "sv") return sv_credit_exhaustion_cover_letters(inputs)
	return en_credit_exhaustion_cover_letters(inputs)
});